// @ts-nocheck
import { request } from 'sonata-react-components';

import type { GeoLookALike } from 'sonata-static-storage/lib/common/common.types';
import type { GeoLookALikeReportInterface } from 'sonata-static-storage/lib/schemas/geoLookALikeReport/geoLookALikeReport.schema';

type CreateInfo = Pick<
  GeoLookALikeReportInterface,
  'campaign' | 'createLayer' | 'name' | 'origin' | 'reportType' | 'variables'
> & {
  user: string;
  userFrom?: string;
};
export async function postGeoLookALike(
  info: CreateInfo,
  report: GeoLookALike,
  token?: Record<string, any>
): Promise<GeoLookALikeReportInterface> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}geoLookALikeReport`,
    {
      data: {
        info,
        report
      },
      method: 'POST'
    },
    token
  );
}

export async function getLastGeoLookALikeReport(
  userId: string,
  campaigns: string[],
  origin: GeoLookALikeReportInterface['origin'],
  token?: Record<string, any>
) {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}geoLookALikeReport/last`,
    {
      data: {
        campaigns,
        origin,
        userId
      },
      method: 'POST'
    },
    token
  );
}

export async function getGeoLookALikeReportUrl(
  reportId: GeoLookALikeReportInterface['reportId'],
  token: Record<string, any>
) {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}geoLookALikeReport/${reportId}/reportUrl`,
    {
      method: 'GET'
    },
    token
  );
}
